import React, { FC } from 'react'

const PotentialMailUsers: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="352"
    height="99"
    viewBox="0 0 352 99"
    fill="none"
  >
    <path
      stroke="#EC1C24"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="3"
      d="M76.995 84H48.066M59.855 65.786h27.857M70.566 74.357h21.429M84.496 84h6.429M64.144 74.357H60.93"
    />
    <path
      stroke="#262A44"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3"
      d="M70.57 83.799v4.62c0 1.702-1.394 3.08-3.116 3.08H5.117C3.395 91.5 2 90.121 2 88.42V45.295c0-1.702 1.395-3.08 3.117-3.08h62.337c1.722 0 3.117 1.378 3.117 3.08v20.022M85.565 10.072 59.69 30.812a3.193 3.193 0 0 1-3.962 0l-25.875-20.74"
    />
    <path
      stroke="#262A44"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3"
      d="M64.143 49.714 38.267 71.491a3.074 3.074 0 0 1-3.961 0L8.43 49.714"
    />
    <path
      stroke="#EC1C24"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="3"
      d="M34.138 24H6.281M23.428 32.572H2M29.852 32.572h3.214"
    />
    <path
      stroke="#262A44"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="3"
      d="M70.182 51.857h18.701c1.723 0 3.117-1.408 3.117-3.147V4.648c0-1.74-1.394-3.148-3.117-3.148H26.547c-1.723 0-3.117 1.409-3.117 3.148v18.884"
    />
    <path
      fill="#EC1C24"
      d="M125.32 53.38c.8 4.214 3.253 6.32 7.36 6.32 2.827 0 4.827-1.253 6-3.76 1.173-2.506 1.76-6.586 1.76-12.24-1.173 1.654-2.773 2.934-4.8 3.84-2.027.907-4.293 1.36-6.8 1.36-3.413 0-6.453-.693-9.12-2.08-2.667-1.44-4.773-3.546-6.32-6.32-1.493-2.826-2.24-6.24-2.24-10.24 0-3.946.8-7.386 2.4-10.32 1.653-2.933 3.973-5.2 6.96-6.8 3.04-1.6 6.613-2.4 10.72-2.4 7.893 0 13.413 2.454 16.56 7.36 3.147 4.907 4.72 12.134 4.72 21.68 0 6.934-.64 12.667-1.92 17.2-1.227 4.48-3.333 7.894-6.32 10.24-2.933 2.347-6.96 3.52-12.08 3.52-4.053 0-7.52-.8-10.4-2.4-2.827-1.6-5.013-3.706-6.56-6.32-1.493-2.613-2.347-5.493-2.56-8.64h12.64Zm6.64-15.28c2.24 0 4.027-.666 5.36-2 1.333-1.386 2-3.253 2-5.6 0-2.56-.693-4.533-2.08-5.92-1.387-1.386-3.253-2.08-5.6-2.08-2.347 0-4.213.72-5.6 2.16-1.333 1.387-2 3.307-2 5.76 0 2.294.667 4.16 2 5.6 1.387 1.387 3.36 2.08 5.92 2.08Zm64.432 15.48c2.08 0 3.73.63 4.95 1.89 1.24 1.26 1.86 3.01 1.86 5.25v9.78h-5.1v-9.09c0-1.08-.29-1.91-.87-2.49-.56-.6-1.34-.9-2.34-.9-1 0-1.79.3-2.37.9-.56.58-.84 1.41-.84 2.49v9.09h-5.1v-9.09c0-1.08-.29-1.91-.87-2.49-.56-.6-1.34-.9-2.34-.9-1 0-1.79.3-2.37.9-.56.58-.84 1.41-.84 2.49v9.09h-5.13V53.76h5.13v2.1c.52-.7 1.2-1.25 2.04-1.65.84-.42 1.79-.63 2.85-.63 1.26 0 2.38.27 3.36.81 1 .54 1.78 1.31 2.34 2.31.58-.92 1.37-1.67 2.37-2.25 1-.58 2.09-.87 3.27-.87Zm15.528-5.28v22.2h-5.13V48.3h5.13Zm13.917 5.28c1.96 0 3.52.64 4.68 1.92 1.18 1.26 1.77 3 1.77 5.22v9.78h-5.1v-9.09c0-1.12-.29-1.99-.87-2.61-.58-.62-1.36-.93-2.34-.93-.98 0-1.76.31-2.34.93-.58.62-.87 1.49-.87 2.61v9.09h-5.13V53.76h5.13v2.22c.52-.74 1.22-1.32 2.1-1.74.88-.44 1.87-.66 2.97-.66Z"
    />
  </svg>
)

export default PotentialMailUsers
